import Amplify from 'aws-amplify';

Amplify.configure({
  Auth: {
    userPoolId: process.env.REACT_APP_AWS_AUTH_USERPOOL_ID,
    region: process.env.REACT_APP_AWS_AUTH_REGION,
    userPoolWebClientId: process.env.REACT_APP_AWS_AUTH_USERPOOL_WEBCLIENT_ID,
  },
});
